import React from 'react';
import { PropTypes as PT } from 'prop-types';
import { FormattedMessage } from 'react-intl';
import onClickOutside from 'react-onclickoutside';
import _compact from 'lodash/compact';
import SVG from 'react-inlinesvg';
import checkIcon from '@lifesize/ux-assets/vectors/svgIcons/check.svg';
import SourceDisplay from 'containers/AvSourceDisplay/AvSourceDisplayContainer';
import InCallSourceDisplay from 'containers/InCallSourceDisplay/InCallSourceDisplayContainer';
import classes from './AvSettingsModal.module.scss';

class AvSettingsModal extends React.Component {
  UNSAFE_componentWillMount() {
    if (!this.props.preserveSettings) {
      this.props.setAudioMuteState(this.props.defaultAudioSetting);
    }
  }

  handleClickOutside() {
    this.props.closeInCallModal();
  }

  render() {
    const {
      rememberSettings,
      toggleRememberSettings,
      isInCall,
      isPSTNVisible } = this.props;

    const containerClasses = _compact([
      classes.container,
      isInCall ? classes.inCall : ''
    ]).join(' ');

    return (
      <div className={containerClasses}>
        {isInCall || isPSTNVisible ?
          <header>
            <div className={classes.headerBar}>
              <FormattedMessage
                id="components.avSettingsModal.changeSettings"
                defaultMessage="Change camera and audio sources"
              />
            </div>
          </header> :
          null
        }
        {this.props.isInCall ?
          <InCallSourceDisplay
            isPSTNVisible={this.props.isPSTNVisible}
          /> :
          <SourceDisplay
            isPSTNVisible={this.props.isPSTNVisible}
          />
        }
        <footer>
          {!this.props.isInCall && !this.props.isPSTNVisible ? (
            <label
              className={classes.checkboxContainer}
              data-testid="chkbox-remember-settings"
            >
              <FormattedMessage
                id="components.avSettingsModal.rememberSettings"
                defaultMessage="Remember for next time"
              />
              <input
                checked={rememberSettings}
                id="rememberSettings"
                name="rememberSettings"
                onChange={toggleRememberSettings}
                type="checkbox"
              />
              <SVG src={checkIcon} data-testid="checkIcon" />
            </label>
          ) : null}
        </footer>
      </div>
    );
  }
}

AvSettingsModal.propTypes = {
  closeInCallModal: PT.func,
  defaultAudioSetting: PT.bool,
  isInCall: PT.bool,
  isPSTNVisible: PT.bool,
  preserveSettings: PT.bool,
  rememberSettings: PT.bool,
  setAudioMuteState: PT.func,
  toggleRememberSettings: PT.func
};

export default onClickOutside(AvSettingsModal);
